import hljs from "highlight.js/lib/core";

window.hljs = hljs;

const hljsLineNumbers = document.getElementById("hljs-line-numbers");
if (!hljsLineNumbers) {
    const src = "https://cdn.jsdelivr.net/npm/highlightjs-line-numbers.js@2.6.0/dist/highlightjs-line-numbers.min.js";
    const script = document.createElement("script");
    script.setAttribute("type", "text/javascript");
    script.setAttribute("src", src);
    document.body.appendChild(script);
}

const replaceHttpMethod = (str, method) => {
    const newStr = `<span class="hljs-http-method hljs-http-method--${method}">${method}</span>`;
    return str.replace(method, newStr);
};

const startsWithHttpMethod = (line) => {
    const REGEXP_PATTERN = /^[GET|POST|PUT|PATCH|DELETE|HEAD|OPTIONS]+/;
    return REGEXP_PATTERN.test(line);
};

const wrapSpanClass = (str, className) => {
    return `<span class="${className}">${str}</span>`;
};

const splitAndRemoveDuplicate = (str, splitRegExp, matchesRegExp) => {
    return str
        .split(splitRegExp)
        .filter(item => matchesRegExp.test(item))
        .filter((item, position, arr) => arr.indexOf(item) == position);
};

const hljsPathParameter = (line) => {
    const arr = splitAndRemoveDuplicate(line, /({.*?})/gi, /(^{.*}$)/gi);
    const len = arr.length;
    for (let i = 0; i < len; i++) {
        const wraped = wrapSpanClass(arr[i], 'hljs-path-parameter');
        line = line.replace(arr[i], wraped);
    }
    return line;
};

const hljsAPI = (htmlCode, codeElement) => {
    const isShell = /(language-sh)/gi.test(codeElement.className);
    if (isShell) {
        codeElement.className += " language-api";
        const lines = htmlCode.split(/\n/);
        const len = lines.length;
        for (let i = 0; i < len; i++) {
            if (startsWithHttpMethod(lines[i])) {
                lines[i] = replaceHttpMethod(lines[i], "GET");
                lines[i] = replaceHttpMethod(lines[i], "POST");
                lines[i] = replaceHttpMethod(lines[i], "PUT");
                lines[i] = replaceHttpMethod(lines[i], "PATCH");
                lines[i] = replaceHttpMethod(lines[i], "DELETE");
                lines[i] = replaceHttpMethod(lines[i], "HEAD");
                lines[i] = replaceHttpMethod(lines[i], "OPTIONS");
            }
            lines[i] = hljsPathParameter(lines[i]);
        }
        htmlCode = lines.join("\n");
    }
    return htmlCode;
};

const hljsHttpURL = (line) => {
    let arr = line.split(/\s+/ig);
    const len = arr.length;
    for (let i = 0; i < len; i++) {
        const isHttp = /^(http)/ig.test(arr[i]);
        if (isHttp) {
            arr[i] = wrapSpanClass(arr[i], 'hljs-url');
        }
    }
    return arr.join(" ");
};

const hljsPlainText = (htmlCode, codeElement) => {
    const isPlainText = /(language-plaintext)/gi.test(codeElement.className);
    if (isPlainText) {
        const isCURL = /^\$\scurl/.test(htmlCode);
        if (isCURL) {
            codeElement.className += " language-curl";
            codeElement.parentElement.className += " language-curl";
            const lines = htmlCode.split(/\n/);
            const len = lines.length;
            for (let i = 0; i < len; i++) {
                const arr = lines[i].split(/(["'].*["'])/gi);
                const l = arr.length;
                for (let j = 0; j < l; j++) {
                    const isString = /^["'].*["']$/.test(arr[j]);
                    if (isString) {
                        arr[j] = wrapSpanClass(arr[j], 'hljs-string');
                    } else {
                        arr[j] = hljsHttpURL(arr[j]);
                    }

                }

                lines[i] = arr.join("");
                const isOutput = /^&gt;/.test(lines[i]);
                if (isOutput) { //&gt; is ">"
                    lines[i] = wrapSpanClass(lines[i], 'hljs-curl-output');
                }
            }
            htmlCode = lines.join("\n");
        } else {
            const lines = htmlCode.split(/\n/);
            const len = lines.length;
            for (let i = 0; i < len; i++) {
                lines[i] = hljsHttpURL(lines[i]);
            }
            htmlCode = lines.join("\n");
        }
    }
    return htmlCode;
};

const hljsInjectParameter = (htmlCode) => {
    const lines = htmlCode.split(/\n/);
    const len = lines.length;
    for (let i = 0; i < len; i++) {
        const arr = splitAndRemoveDuplicate(lines[i], /((&lt;).*?(&gt;))/gi, /(^(&lt;).*(&gt;)$)/gi);
        const l = arr.length;
        for (let j = 0; j < l; j++) {
            const wraped = wrapSpanClass(arr[j], 'hljs-inject-parameter');
            lines[i] = lines[i].replace(arr[j], wraped);
        }
    }
    return lines.join("\n");
};

export default {
    init() {
        const t = setTimeout(() => {
            clearTimeout(t);

            const codeElements = document.querySelectorAll("code.hljs");
            const len = codeElements.length;
            for (let i = 0; i < len; i++) {
                const codeElement = codeElements[i];
                codeElement.parentElement.className = "hljs-code-wrapper";
                //
                let html = codeElement.innerHTML;
                html = hljsAPI(html, codeElement);
                html = hljsPlainText(html, codeElement);
                html = hljsInjectParameter(html);
                codeElement.innerHTML = html;
            }

            if (hljs.initLineNumbersOnLoad) {
                hljs.initLineNumbersOnLoad({
                    singleLine: true,
                });
            }
        }, 50);
    }
};